import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { useContext } from 'react';
import { ThemeContext } from '../../ThemeContext';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import { Button, Grid, useTheme } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';
import { CommonHeading, DesignBtn } from '../Common';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TwitterIcon from '@mui/icons-material/Twitter';
import CallIcon from '@mui/icons-material/Call';
import TelegramIcon from '@mui/icons-material/Telegram';
import EmailIcon from '@mui/icons-material/Email';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addCart, removeProduct } from '../../redux/actions/cartActions';
import { Google } from '@mui/icons-material';


const Header = () => {
    const count = useSelector(state => state?.counter);
    console.log("countcountcount", count);
    const dispatch = useDispatch();
    const isCartOpen = useSelector((state) => state.counter.isCartOpen);
    console.log("count?.productscount?.products", count?.products);



    const theme = useTheme();
    const navigate = useNavigate();
    const pages = [
        {
            name: 'home',
            link: '/'
        },
        {
            name: 'about us',
            link: '/about'
        },
        {
            name: 'gallery',
            link: '/gallery'
        },
        {
            name: 'shop',
            link: '/shop'
        },
        {
            name: 'contact',
            link: '/contact'
        },
    ];

    const [state, setState] = React.useState({
        right: false,
        left: false
    });

    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open });
    };

    const handleOpenSidebar = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open });
    };

    const { themeMode, toggleTheme } = useContext(ThemeContext);

    const handleThemeToggle = () => {
        toggleTheme();
    };

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const galleryImage = [
        {
            imageSrc: "/images/header/blog-instagram-1.jpg",
            alt: "image"
        },
        {
            imageSrc: "/images/header/blog-instagram-1.jpg",
            alt: "image"
        },
        {
            imageSrc: "/images/header/blog-instagram-1.jpg",
            alt: "image"
        },
        {
            imageSrc: "/images/header/blog-instagram-1.jpg",
            alt: "image"
        },
        {
            imageSrc: "/images/header/blog-instagram-1.jpg",
            alt: "image"
        },
        {
            imageSrc: "/images/header/blog-instagram-1.jpg",
            alt: "image"
        },
        {
            imageSrc: "/images/header/blog-instagram-1.jpg",
            alt: "image"
        },
        {
            imageSrc: "/images/header/blog-instagram-1.jpg",
            alt: "image"
        },
    ]

    const socialIcon = [
        {
            icon: FacebookOutlinedIcon,
            link: "https://www.facebook.com/share/14E9VpYBi69/",
        },
        {
            icon: InstagramIcon,
            link: "https://www.instagram.com/invites/contact/?i=ki6sr7vaduel&utm_content=ptc963b",
        },
        {
            icon: WhatsAppIcon,
            link: "https://wa.me/qr/SV3HEFPLHBAYP1",
        },
        {
            icon: TelegramIcon,
            link: "https://t.me/jaykhodiyarfashion",
        },
        {
            icon: Google,
            link: " https://g.co/kgs/KcSmyUx",
        },
    ]

    const contactdetail = [
        {
            icon: CallIcon,
            text: '9099126650'
        },
        {
            icon: EmailIcon,
            text: 'nakranimahesh102@gmail.com'
        },
    ]

    const [AllCartData, setAllCartData] = useState(count?.products);

    // const countqqq = useSelector((state) => state.cart);


    // useEffect(() => {
    //     let getAllData = JSON.parse(localStorage.getItem("cartData"));
    //     if (count?.products?.length > 0) {
    //         console.log("count?.productscount?.productscount?.productscount?.products",count?.products);

    //         setAllCartData(count?.products);
    //     } else {
    //         setAllCartData([]);
    //     }
    // }, [])


    const calculateTotalPrice = () => {
        let totalPrice = 0;
        count?.products?.forEach(item => {
            totalPrice += item.product[0]?.ProductPrice * item.count;
        });
        return totalPrice;
    };

    const removeFromCart = (item) => {
        const removeData = count?.products.filter((val) => val.product[0].unqid !== item.product[0].unqid);
        const unqid = item.product[0].unqid;

        dispatch(removeProduct(unqid));
        localStorage.setItem('cartData', JSON.stringify(removeData));
        setAllCartData(removeData);
    }

    const CheckOutProduct = () => {
        navigate("/cartpage");
        dispatch({ type: "CLOSE_CART" });
        setTimeout(() => {
            window.location.reload();
        }, 500);
    }

    useEffect(() => {
        setTimeout(() => {
            dispatch({ type: "CLOSE_CART" });
        }, 0);
    }, []);

    return (
        <>
            <AppBar sx={{
                backgroundColor: theme.palette.background.default,
            }}>
                <Toolbar sx={{
                    height: 'auto',
                    py: 2,
                    minHeight: 'auto !important',
                    borderBottom: `2px solid ${theme.palette.primary.border}`,
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{ mt: 0, width: '140px' }}>
                        <Link to="/">
                            <img src="/images/header/Light-logo.svg" width="100%" height='100%' />
                        </Link>
                    </Box>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'center' }}>
                        {pages.map((val, index) => (
                            <Link
                                to={val.link}
                                key={index}
                                onClick={handleCloseNavMenu}
                            >
                                <Typography sx={{
                                    color: theme.palette.primary.main,
                                    display: 'block',
                                    fontFamily: theme.palette.typography.fontFamily1,
                                    fontSize: { md: '14px', xs: '12px' },
                                    fontWeight: 400,
                                    letterSpacing: 1,
                                    mx: { lg: 4, md: 3.2 },
                                    textTransform: 'uppercase',
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    position: 'relative',
                                    transition: 'all .3s ease-in-out',
                                    '&::after': {
                                        content: "''",
                                        position: 'absolute',
                                        bottom: -1,
                                        left: 0,
                                        width: '0',
                                        height: '1px',
                                        transition: 'all .3s ease-in-out',
                                        backgroundColor: theme.palette.primary.gold
                                    },
                                    '&:hover': {
                                        color: theme.palette.primary.gold,
                                    },
                                    '&:hover::after': {
                                        width: '100%',
                                    }
                                }}>
                                    {val.name}

                                </Typography>
                            </Link>
                        ))}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box onClick={() => dispatch({ type: 'TOGGLE_CART' })} sx={{ mx: { md: 3, sm: 2, xs: 1 }, cursor: 'pointer' }}>
                            <Box sx={{
                                cursor: 'pointer',
                                position: 'relative',
                                '&::after': {
                                    content: `"${count?.product_card}"`,
                                    position: 'absolute',
                                    top: -6,
                                    right: -6,
                                    paddingY: .2,
                                    paddingX: .7,
                                    fontSize: '10px',
                                    fontFamily: theme.palette.typography.fontFamily1,
                                    borderRadius: '50px',
                                    backgroundColor: theme.palette.primary.gold
                                },
                                '&:hover .cart-main': {
                                    opacity: 1,
                                    transform: 'translateY(0px)',
                                },

                            }}>
                                <img src="/images/header/cart.svg" />
                            </Box>
                        </Box>
                        <Box sx={{ display: { md: 'none', xs: 'block' } }}>
                            <Box onClick={handleOpenSidebar("left", true)}>
                                {
                                    state.left
                                        ? <ClearAllIcon sx={{ fontSize: '30px', mt: .5, ml: { md: 3, sm: 2, xs: 1 } }} />
                                        : <MenuIcon sx={{ fontSize: '30px', mt: .5, ml: { md: 3, sm: 2, xs: 1 } }} />
                                }
                            </Box>
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar >
            <Box>

                <React.Fragment key={'right'} sx={{ backgroundColor: theme.palette.background.brownDark }}>
                    <Drawer
                        anchor={'right'}
                        open={isCartOpen}
                        sx={{ backgroundColor: theme.palette.background.default }}
                    >
                        <Box
                            sx={{
                                width: { sm: 350, xs: 280 },
                                height: { sm: '100vh', xs: '101vh' },
                                backgroundColor: theme.palette.background.brownDark,
                                p: { sm: 5, xs: 3 },
                                overflowX: 'hidden'
                            }}
                            role="presentation"
                        >
                            <Box
                                onClick={() => dispatch({ type: "CLOSE_CART" })}
                                sx={{
                                    cursor: 'pointer',
                                    background: theme.palette.background.default,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '50px',
                                    width: '40px',
                                    height: '40px',
                                    float: 'right',
                                    border: `1px solid ${theme.palette.background.default}`,
                                    transition: 'all 0.3s linear 0s',
                                    '&:hover': {
                                        border: `1px solid ${theme.palette.primary.main}`
                                    }
                                }}>
                                <CloseIcon />
                            </Box>
                            <Box sx={{ mt: 8 }}>
                                {count?.products?.map((item, i) => (
                                    <Box key={i} sx={{ display: 'flex', gap: 2, position: 'relative', py: 2.4, borderBottom: '1px solid rgba(240,240,240,.4)' }}>
                                        <Box onClick={() => removeFromCart(item)} sx={{
                                            position: 'absolute',
                                            px: .4,
                                            pt: .4,
                                            backgroundColor: 'rgba(240,240,240,.4)',
                                            borderRadius: '50px',
                                            cursor: 'pointer',
                                            top: 16,
                                            right: 0,
                                            transition: 'all .3s ease-in-out',
                                            '&:hover': {
                                                backgroundColor: theme.palette.primary.gold
                                            }
                                        }}>
                                            <CloseIcon sx={{ fontSize: '14px' }} />
                                        </Box>
                                        <Box sx={{ border: `1px solid rgba(240,240,240,0.15)`, pt: .5, px: .5 }}>
                                            {/* <img src={`${process.env.REACT_APP_BACKEND_APP}/uploads/` + item.product[0]?.ProductImage} width={'70px'} height={'auto'} style={{ objectFit: 'cover' }} /> */}
                                            <img src={item.product[0]?.ProductImage} width={'70px'} height={'auto'} style={{ objectFit: 'cover' }} />
                                        </Box>
                                        <Box>
                                            <Typography sx={{
                                                fontFamily: theme.palette.typography.fontFamily1,
                                                fontWeight: 500,
                                                transition: 'all .3s ease-in-out',
                                                cursor: 'pointer',
                                                fontSize: '18px',
                                                '&:hover': {
                                                    color: theme.palette.primary.gold
                                                }
                                            }}>
                                                {item.product[0]?.ClothesType}
                                            </Typography>
                                            {
                                                item.product[0]?.FabricType == "Kurta" ? (
                                                    <>
                                                        <Box sx={{ display: 'flex', gap: 2 }}>
                                                            <Typography sx={{
                                                                mt: 1,
                                                                fontFamily: theme.palette.typography.fontFamily1,
                                                                fontWeight: 500,
                                                                fontSize: '14px'
                                                            }}>
                                                                Kurta : <Box component='span' sx={{ fontWeight: 300 }}>{item.product[0]?.KurtaMeter}</Box>
                                                            </Typography>
                                                            <Typography sx={{
                                                                mt: 1,
                                                                fontFamily: theme.palette.typography.fontFamily1,
                                                                fontWeight: 500,
                                                                fontSize: '14px'
                                                            }}>
                                                                Trouser : <Box component='span' sx={{ fontWeight: 300 }}>{item.product[0]?.TrouserMeter}</Box>
                                                            </Typography>
                                                        </Box>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Box sx={{ display: 'flex', gap: 2 }}>
                                                            <Typography sx={{
                                                                mt: 1,
                                                                fontFamily: theme.palette.typography.fontFamily1,
                                                                fontWeight: 500,
                                                                fontSize: '14px'
                                                            }}>
                                                                Shirt : <Box component='span' sx={{ fontWeight: 300 }}>{item.product[0]?.ShirtMeter}</Box>
                                                            </Typography>
                                                            <Typography sx={{
                                                                mt: 1,
                                                                fontFamily: theme.palette.typography.fontFamily1,
                                                                fontWeight: 500,
                                                                fontSize: '14px'
                                                            }}>
                                                                Paint : <Box component='span' sx={{ fontWeight: 300 }}>{item.product[0]?.PaintMeter}</Box>
                                                            </Typography>
                                                        </Box>
                                                    </>
                                                )

                                            }
                                            <Typography sx={{
                                                mt: 1,
                                                fontFamily: theme.palette.typography.fontFamily1,
                                                fontWeight: 500,
                                                transition: 'all .3s ease-in-out',
                                                cursor: 'pointer',
                                                fontSize: '12px',
                                            }}>
                                                {item.count} × {item.product[0]?.ProductPrice}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ))}
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2 }}>
                                    <Typography variant='h6' sx={{ fontWeight: 800, fontFamily: theme.palette.typography.fontFamily1 }}>
                                        Total :
                                    </Typography>
                                    <Typography variant='h6' sx={{ fontWeight: 800, fontFamily: theme.palette.typography.fontFamily1 }}>
                                        ₹ {calculateTotalPrice()}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Button onClick={CheckOutProduct} sx={{ width: "100%", bgcolor: theme.palette.primary.gold, mt: 2, borderRadius: 0, py: 1, fontSize: "18px" }}>
                                        Check Out
                                    </Button>
                                </Box>
                                <Box sx={{ my: 5 }}>
                                    <CommonHeading text={"We are Social"} fontSize={"32px"} fontWeight={"400"} />
                                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                                        {socialIcon.map((item, i) => (
                                            <a
                                                key={i}
                                                href={item?.link}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '8px 8px',
                                                    border: `1px solid ${theme.palette.primary.main}`,
                                                    borderRadius: '50px',
                                                    textAlign: 'center',
                                                    margin: '0 8px',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s ease-in-out',
                                                    color: 'inherit',
                                                    textDecoration: 'none',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.border = `1px solid ${theme.palette.primary.gold}`;
                                                    e.currentTarget.style.color = theme.palette.primary.gold;
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.border = `1px solid ${theme.palette.primary.main}`;
                                                    e.currentTarget.style.color = 'inherit';
                                                }}
                                            >
                                                <item.icon style={{ marginTop: '2px' }} />
                                            </a>
                                        ))}
                                    </Box>

                                </Box>
                                <Box sx={{ my: 4 }}>
                                    <CommonHeading text={"Contact Us"} fontSize={"32px"} fontWeight={"400"} />
                                    <Box sx={{ display: 'flex', alignItems: { sm: 'center', xs: 'start' }, mt: 2, gap: 2, flexDirection: { sm: 'row', xs: 'column' } }}>
                                        {contactdetail.map((item, i) => (
                                            <Box key={i} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }} >
                                                <item.icon sx={{ fontSize: '20px', mr: 1 }} />
                                                <Typography sx={{
                                                    color: theme.palette.primary.main,
                                                    fontSize: '14px',
                                                    transition: 'all .3s ease-in-out',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        color: theme.palette.primary.gold
                                                    }
                                                }}>
                                                    {item.text}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Drawer>
                </React.Fragment>

            </Box>
            <Box>
                {['left'].map((anchor) => (
                    <React.Fragment key={'left'} sx={{ backgroundColor: theme.palette.background.brownDark }}>
                        <Drawer
                            anchor={'left'}
                            open={state['left']}
                        >
                            <Box
                                sx={{
                                    width: { sm: 350, xs: 280 },
                                    height: { sm: '100vh', xs: '101vh' },
                                    backgroundColor: theme.palette.primary.gold,
                                    p: { sm: 5, xs: 3 },
                                    overflowX: 'hidden'
                                }}
                                role="presentation"
                            >
                                <Box
                                    onClick={toggleDrawer(anchor, false)}
                                    sx={{
                                        cursor: 'pointer',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: '50px',
                                        width: '40px',
                                        color: '#000',
                                        height: '40px',
                                        float: 'right',
                                        transition: 'all 0.3s linear 0s',
                                    }}>
                                    <CloseIcon />
                                </Box>
                                <Box sx={{ mt: 8 }}>
                                    {
                                        pages.map((item, i) => (
                                            <Box key={i} sx={{
                                                py: 2,
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                '&:nth-child(4)': {
                                                    borderBottom: 0,
                                                }
                                            }}>
                                                <Link to={item.link} sx={{ color: '#000 !important' }}>

                                                    <Typography sx={{ textTransform: 'uppercase', fontFamily: theme.palette.typography.fontFamily1 }}>
                                                        <Box onClick={handleOpenSidebar("left", false)} sx={{ color: '#000 !important' }}>
                                                            {item.name}
                                                        </Box>
                                                    </Typography>
                                                </Link>
                                                {/* <KeyboardDoubleArrowRightIcon /> */}
                                            </Box>
                                        ))
                                    }
                                </Box>
                            </Box>
                        </Drawer>
                    </React.Fragment>
                ))}
            </Box>
        </>
    )
}

export default Header
